<div class="inner">
	<div class="img">
		<img [src]="image(conf.configurationModel)" [alt]="'IMAGEALTS.CONFIGURATION' | translate" />
		@if (conf.containDetails) {
		<i [ngClass]="[showDetail ? 'icon-info-clicked' : 'icon-info-notclicked', 'information-icon']" (click)="showDetails();$event.stopPropagation()"></i>
		}
	</div>

	@if (conf.modelConfigurationDescription) {
	<div class="title">
		<h6><b>{{conf.modelConfigurationDescription}}</b></h6>
	</div>
	}

	@if (conf.modelConfigurationDescription2) {
	<div class="description">
		@if (conf.modelConfigurationDescription2Prefix) {
		<div class="column-seperated">
			<div class="font-medium">
				{{conf.modelConfigurationDescription2Prefix | translate }}
			</div>
			<div>{{conf.modelConfigurationDescription2}}</div>
		</div>
		}
		@if (!conf.modelConfigurationDescription2Prefix) {
		<div>
			<div>{{conf.modelConfigurationDescription2}}</div>
		</div>
		}
	</div>
	}

	@if (conf.modelConfigurationDescription2Prefix) {
	<div>
		@for (colorDescriptionModel of conf.colorDescriptions; track colorDescriptionModel) {
		<div class="description column-seperated">
			<div></div>
			<div>{{colorDescriptionModel | dataTranslate | translate}}</div>
		</div>
		}
	</div>
	}

	@if (!conf.modelConfigurationDescription2Prefix) {
	<div>
		@for (colorDescriptionModel of conf.colorDescriptions; track colorDescriptionModel) {
		<div class="description">
			<div>{{colorDescriptionModel | dataTranslate | translate}}</div>
		</div>
		}
	</div>
	}

	@for (variant of conf.variantsToShow; track variant) {
	<div class="description">
		<div class="column-seperated">
			<div class="font-medium">{{ variant.prefixTranslate | translate }}</div>
			<div>{{variant.colorCode}}</div>
		</div>
		<div class="column-seperated">
			<div></div>
			@if (!conf.containDetails) {
			<div>{{variant.description2 | dataTranslate | translate}}</div>
			}
		</div>
	</div>
	}

	@if (showDetail) {
	<div class="description text">
		<p [innerHTML]="conf.variantsToShow[0].description | dataTranslate | translate"></p>
		<p [innerHTML]="conf.variantsToShow[0].description2 | dataTranslate | translate"></p>
		<i class="icon-lens-table details-icon"></i>
	</div>
	}

	<div class="description">
		<h6>
			<availability-text [variantOrModelIsNew]="variantOrModelIsNew" [date]="conf.Discontinued!==null ? conf.Discontinued : conf.configurationModel.configurationModel.Discontinued" [new]="conf.configurationModel.configurationModel.New" [useNewDetails]="false"></availability-text>
		</h6>
	</div>
</div>
@if (selected && showOverlay) {
<menu-overlay
	[mainOverlayText]="null"
	[secondOverlayText]="'CUSTOMIZER.CHANGES.BAGUPDATED' | translate"
	(overlayClicked)="null">
</menu-overlay>
}